import { ChevronDownIcon } from 'components/icons';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';
import { FC, ReactNode, useState } from 'react';
import { cn } from 'utils/cn';

export interface NavigationMenuItem {
    handler: () => void;
    title: string;
    icon?: ReactNode;
}

interface Props {
    menuItems: NavigationMenuItem[];
    title: string;
}

/** The dropdown tab of a tab strip: a label with a chevron that opens a menu of sub-views. */
const NavigationMenu: FC<Props> = ({ menuItems, title }) => {
    const [open, setOpen] = useState(false);
    const disabled = menuItems.length === 0;

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            {/* A span, not a button: the trigger sits inside the tab's own <button>. The dropdown tab
                drops its padding, so the trigger carries it and the whole tab surface opens the menu. */}
            <DropdownMenuTrigger
                nativeButton={false}
                disabled={disabled}
                render={<span />}
                className={cn(
                    'flex h-full items-center gap-1.5 px-3.5 py-3',
                    disabled && 'text-grey-300 cursor-default'
                )}
            >
                {title}
                <ChevronDownIcon
                    className={cn('text-primary size-4 transition-transform duration-200', open && 'rotate-180')}
                />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-auto">
                {menuItems.map((menuItem) => (
                    <DropdownMenuItem key={menuItem.title} onClick={menuItem.handler}>
                        {menuItem.title}
                        {menuItem.icon}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default NavigationMenu;
